import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import setShowWeatherOption from '../data/mutators/setShowWeatherOption';
import selectWeatherUnitOption from '../data/mutators/selectWeatherUnitOption';
import getWeatherOptions from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { OptionsCheckbox } from 'owa-options-controls';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var WeatherFull = /** @class */ (function (_super) {
    tslib_1.__extends(WeatherFull, _super);
    function WeatherFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onWeatherShowChange = function (ev, checked) {
            setShowWeatherOption(checked);
        };
        _this.onWeatherUnitChange = function (ev, option) {
            selectWeatherUnitOption(parseInt(option.key));
        };
        return _this;
    }
    WeatherFull.prototype.render = function () {
        var optionStore = getWeatherOptions();
        var calendarConfiguration = getCalendarConfiguration();
        var weatherEnabledStatus = getFallbackValueIfNull(optionStore.weatherEnabled, calendarConfiguration.WeatherEnabled);
        var isWeatherEnabled = weatherEnabledStatus !== 1 /* Disabled */;
        var weatherUnit = getFallbackValueIfNull(optionStore.weatherUnit, calendarConfiguration.WeatherUnit
            ? calendarConfiguration.WeatherUnit
            : 2 /* Fahrenheit */);
        return (React.createElement("div", null,
            React.createElement(OptionsCheckbox, { label: strings.options_weather_enabled, checked: isWeatherEnabled, onChange: this.onWeatherShowChange }),
            React.createElement(ChoiceGroup, { selectedKey: "" + weatherUnit, label: strings.options_weather_unitLabel, options: [
                    {
                        key: 2 /* Fahrenheit */.toString(),
                        text: strings.options_weather_fahrenheit,
                    },
                    {
                        key: 1 /* Celsius */.toString(),
                        text: strings.options_weather_celsius,
                    },
                ], onChange: this.onWeatherUnitChange, disabled: !isWeatherEnabled })));
    };
    WeatherFull = tslib_1.__decorate([
        observer
    ], WeatherFull);
    return WeatherFull;
}(React.Component));
export default WeatherFull;
//# sourceMappingURL=WeatherFull.js.map